// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel__QNHnn","resetButton":"styles_resetButton__l5ktg","saveButton":"styles_saveButton__8Dkol","chatSettingsSeparator":"styles_chatSettingsSeparator__KTcgN"};